import React, { type ReactNode, createContext, useContext } from 'react';

import { AuthProvider } from './AuthContext';

// Global app state
type AppContextType = {};

const AppContext = createContext<AppContextType | null>(null);

interface AppProviderProps {
  children: ReactNode;
}

export function AppProvider({ children }: AppProviderProps) {
  return (
    <AppContext.Provider value={null}>
      <AuthProvider>{children}</AuthProvider>
    </AppContext.Provider>
  );
}

export function useApp() {
  const context = useContext(AppContext);

  if (!context) throw new Error('useApp must be used within an AppProvider');

  return context;
}

export type { AppContextType };
